import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase/app'
import 'firebase/auth'

import Home from '@/views/Home.vue'
import Products from '@/views/Products.vue'
import Portfolio from '@/views/Portfolio.vue'
import Admin from '@/views/Admin.vue'
import Blog from '@/views/Blog.vue'
import NotFound from '@/views/404.vue'
import AdminHome from '@/views/admin/AdminHome.vue'
import IctConsultancy from '@/views/details/IctConsultancy.vue'
import IctTraining from '@/views/details/IctTraining.vue'
import Networking from '@/views/details/Networking.vue'
import WebDevelopment from '@/views/details/WebDevelopment.vue'
import Messages from '@/views/admin/Messages.vue'
import NewPost from '@/views/admin/NewPost.vue'
import Account from '@/views/admin/Account.vue'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/products',
      name: 'products',
      component: Products
    },
    {
      path: '/portfolio',
      name: 'portfolio',
      component: Portfolio
    },
    {
      path: '/blog',
      name: 'blog',
      component: Blog
    },
    {
      path: '/ictConsultancy',
      name: 'ictConsultancy',
      component: IctConsultancy
    },
    {
      path: '/ictTraining',
      name: 'ictTraining',
      component: IctTraining
    },
    {
      path: '/networking',
      name: 'networking',
      component: Networking
    },
    {
      path: '/webDevelopment',
      name: 'webDevelopment',
      component: WebDevelopment
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      meta: {
        requiresAuth: true
      },
      children: [{
        path: '/admin',
        component: AdminHome
      },
      {
        path: 'messages',
        component: Messages
      },
      {
        path: 'newPost',
        component: NewPost
      },
      {
        path: 'account',
        component: Account
      }
      ]
    },
    {
      path: '*',
      component: NotFound
    }
  ]
})

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && !currentUser) next('/')
  else if (!requiresAuth && currentUser) next()
  else next()
})

export default router
